import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
import { COLORES, ESPACIOS, CAJAS } from '@/constantes/catalogosIniciales.js'
const storage = firebase.storage().ref()
var cargadorFranquicia = null
var cargadorIndiceSucursales = null
var cargadorIndiceSucursalesTemp = null
var cargadorSucursalActual = null
const store = {
  state: {
    franquicia: {},
    franquiciaEdicion: {},
    indiceFranquicias: [],
    indiceGeneralFranquicias: {},
    indiceSucursales: [],
    indiceSucursalesTemp: [],
    sucursal_activa: {},
    sucursal_activa_local: {},
    indiceGeneralSucursales: {},
  },
  getters: {
    franquicia: state => {
      return state.franquicia
    },
    franquiciaEdicion: state => {
      return state.franquiciaEdicion
    },
    indiceFranquicias: state => {
      return state.indiceFranquicias
    },
    indiceSucursales: state => {
      return state.indiceSucursales
    },
    indiceSucursalesTemp: state => {
      return state.indiceSucursalesTemp
    },
    sucursal_activa: state => {
      return state.sucursal_activa
    },
    sucursal_activa_local: state => {
      return state.sucursal_activa_local
    },
    indiceGeneralSucursales: state => {
      return state.indiceGeneralSucursales
    },
    indiceGeneralFranquicias: state => {
      return state.indiceGeneralFranquicias
    },
  },
  mutations: {
    ASIGNA_FRANQUICIA(state, franquicia) {
      state.franquicia = franquicia
    },
    ASIGNA_FRANQUICIA_EDICION(state, franquiciaEdicion) {
      state.franquiciaEdicion = franquiciaEdicion
    },
    ASIGNA_INDICE_FRANQUICIAS(state, franquicias) {
      state.indiceFranquicias = franquicias
    },
    ASIGNA_INDICE_GENERAL_FRANQUICIAS(state, franquicias) {
      state.indiceGeneralFranquicias = franquicias
    },
    ASIGNA_INDICE_SUCURSALES(state, sucursales) {
      state.indiceSucursales = sucursales
    },
    ASIGNA_INDICE_GENERAL_SUCURSALES(state, sucursales) {
      state.indiceGeneralSucursales = sucursales
    },
    ASIGNA_INDICE_SUCURSALES_TEMP(state, sucursales) {
      state.indiceSucursalesTemp = sucursales
    },
    ASIGNA_SUCURSAL_ACTUAL(state, sucursal_activa) {
      state.sucursal_activa = sucursal_activa
    },
    ASIGNA_SUCURSAL_ACTUAL_LOCAL(state, sucursal_activa_local) {
      state.sucursal_activa_local = sucursal_activa_local
    },
  },
  actions: {
    cargaFranquicia({ commit, getters, dispatch }, id) {
      return new Promise((resolve, reject) => {
        console.log('cargaFranquicia2: ' + id)
        let idFranquiciaActual = getters.franquicia.id
        if (idFranquiciaActual !== id) {
          console.log('Cambio de franquicia')
          let docPath = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(id)
          if (cargadorFranquicia !== null) {
            cargadorFranquicia()
            console.log('cargadorFranquicia()')
          }
          cargadorFranquicia = docPath.onSnapshot(doc => {
            //console.log('Current data: ', doc.data())
            console.log('onSnapshot()')
            let franquicia = doc.data()
            franquicia.id = id
            //TODO: Forzar carga de todos los catálogos necesarios
            commit('ASIGNA_INDICE_PACIENTES', null)
            commit('ASIGNA_INDICE_USUARIOS', null)
            commit('ASIGNA_INDICE_PROPIETARIOS', null)
            commit('ASIGNA_FRANQUICIA', franquicia)
            commit('ASIGNA_CORPORATIVO', { id: franquicia.id_corporativo })
            resolve()
          })
        }
      })
    },
    cambiaFranquicia({ getters, dispatch }, idNuevaFranquicia) {
      let docUser = db
        .collection(FS_COLLECTIONS.USUARIOS)
        .doc(getters.usuario.id)
      dispatch('cargaFranquicia', idNuevaFranquicia)
      docUser.update({ id_franquicia: idNuevaFranquicia })
    },
    cargaFranquiciasCorporativo({ commit }, franquicias) {
      var items = []
      for (var key in franquicias) {
        items.push(franquicias[key])
      }
      commit('ASIGNA_INDICE_FRANQUICIAS', items)
    },
    actualizarFranquicia({ }, franquicia) {
      return db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(franquicia.id)
        .update(franquicia)
    },
    agregarFranquicia({ dispatch, getters }, franquicia) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .add(franquicia)
          .then(docRefFranquicia => {
            let payloadFranquicia = {
              idFranquicia: docRefFranquicia.id,
              usuario: getters.usuario
            }
            dispatch('crearCatalogosFranquicia', payloadFranquicia)
              .then(idFranquicia => {
                resolve(idFranquicia)
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // Sucursales
    cargaIndiceSucursales({ commit, getters }, idFranquicia) {
      //if (cargadorIndiceSucursales === null) {
      ///Franquicias/BF2Iny6XE5EeQLqPErQv/Indices/Propietarios
      return new Promise(resolve => {
        if (getters.indiceSucursales === null) {
          if (typeof cargadorIndiceSucursales === 'function') {
            cargadorIndiceSucursales()
          }
          cargadorIndiceSucursales = null
          console.log('getters.indicePacientes === null')
        }

        if (cargadorIndiceSucursales === null) {
          console.log('franquicia.id: ' + idFranquicia)

          let docPath = db
            .collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(idFranquicia)
            .collection(FS_COLLECTIONS.INDICES)
            .doc(FS_COLLECTIONS.SUCURSALES)
          console.log(docPath)
          cargadorIndiceSucursales = docPath.onSnapshot(doc => {
            console.log('Current data suc1: ', doc.data())
            commit('ASIGNA_INDICE_SUCURSALES', doc.data())
            resolve(getters.indiceSucursales)
          })
        } else {
          resolve(getters.indiceSucursales);
        }
      })

      //}
    },
    cargaIndiceGeneralSucursales({ commit },) {

      return new Promise(resolve => {

        db.collection(FS_COLLECTIONS.INDICES).doc(FS_COLLECTIONS.SUCURSALES).onSnapshot(doc => {

          let items = {}

          for (const id in doc.data()) {
            items[id] = {
              ...doc.data()[id],
              id
            }
          }

          commit('ASIGNA_INDICE_GENERAL_SUCURSALES', items)
          resolve(items)

        })

      })

    },
    cargaIndiceGeneralFranquicias({ commit },) {
      return new Promise(resolve => {

        db.collection(FS_COLLECTIONS.INDICES).doc(FS_COLLECTIONS.FRANQUICIAS).onSnapshot(doc => {

          let items = {}

          for (const id in doc.data()) {
            items[id] = {
              ...doc.data()[id],
              id
            }
          }

          commit('ASIGNA_INDICE_GENERAL_FRANQUICIAS', items)
          resolve(items)

        })

      })
    },
    cargaIndiceSucursalesTemp({ commit }, payload) {
      //if (cargadorIndiceSucursalesTemp === null) {
      ///Franquicias/BF2Iny6XE5EeQLqPErQv/Indices/Propietarios
      return new Promise((resolve, reject) => {
        let idFranquicia = payload.idFranquicia

        console.log('cargaIndiceSucursalesTemp franquicia.id: ' + idFranquicia)
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.INDICES)
          .doc(FS_COLLECTIONS.SUCURSALES)

        if (cargadorIndiceSucursalesTemp !== null) {
          cargadorIndiceSucursalesTemp()
          cargadorIndiceSucursalesTemp = null
        }
        cargadorIndiceSucursalesTemp = docPath.onSnapshot(doc => {
          console.log('Current data suc2: ', doc.data())
          if (payload.asigna) {
            commit('ASIGNA_INDICE_SUCURSALES_TEMP', doc.data())
          }
          resolve(doc.data())
        })
      })
      //}
    },
    asignaSucursal({ commit, getters }, sucursal) {
      let idUsuario = getters.usuario.id
      db.collection(FS_COLLECTIONS.USUARIOS)
        .doc(idUsuario)
        .update({ sucursal_actual: sucursal })

      //commit('ASIGNA_SUCURSAL', sucursal)
    },
    asignaAlmacen({ getters }, id_almacen) {
      let idUsuario = getters.usuario.id
      db.collection(FS_COLLECTIONS.USUARIOS)
        .doc(idUsuario)
        .update({ id_almacen: id_almacen })

      //commit('ASIGNA_SUCURSAL', sucursal)
    },
    agregarSucursal({ getters, dispatch }, sucursal) {
      var user = firebase.auth().currentUser

      let listaEspacios = getters.listaEspacios;
      let listaCajas = getters.listaCajas;
      //console.log("TCL: agregarSucursal -> listaEspacios", listaEspacios)

      // User Identifier
      sucursal.usuario_padre = user.uid
      sucursal.estatus_pago = { tipo: 'de_paga' };
      sucursal.configuracion_agenda = {
        duracion_citas: 15,
        tiempo_espera: 5
      };

      sucursal.cajas_abiertas = []

      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.SUCURSALES)
          .add(sucursal)
          .then(docRef => {
            let refSucursales = db
              .collection(FS_COLLECTIONS.SUCURSALES)
              .doc(docRef.id)
            let refSucursalesIndices = refSucursales.collection(FS_COLLECTIONS.INDICES)
            //Creamos una lista de agendas a nivel sucursal
            let agendas = refSucursalesIndices.doc(FS_COLLECTIONS.AGENDA)
            agendas.set({ dataSource: [] })

            dispatch('asignarSucursalEnAlmacenes', {
              id_sucursal: docRef.id,
              almacenes: sucursal.almacenes,
            })

            //Obtenemos la referencia a la Colección de catalogos
            let idFranquicia = sucursal.id_franquicia
            let refFranquicia = db
              .collection(FS_COLLECTIONS.FRANQUICIAS)
              .doc(idFranquicia)
            let refCatalogos = refFranquicia.collection(FS_COLLECTIONS.CATALOGOS)

            //Creamos una lista de espacios a nivel franquicia
            let refEspacios = refCatalogos.doc(FS_COLLECTIONS.ESPACIOS)
            //let espacios = { activo: true, nombre: 'Consultorio 1', sucursal: {} };
            let espacios = ESPACIOS
            espacios.Espacios[0].sucursal = {
              id: docRef.id,
              nombre: sucursal.info.nombre
            }
            espacios.Espacios[0].id_temporal = listaEspacios.Espacios.length;
            //espacios.id_temporal=listaEspacios.Espacios.length;
            listaEspacios.Espacios.push(espacios.Espacios[0]);
            refEspacios.set(listaEspacios)


            //Creamos una lista de cajas a nivel franquicia
            let refCajas = refCatalogos.doc(FS_COLLECTIONS.CAJAS)
            //let cajas = { activo: true, nombre: 'Caja 1', sucursal: {} };
            let cajas = CAJAS
            cajas.Cajas[0].sucursal = {
              id: docRef.id,
              nombre: sucursal.info.nombre,
              telefono: '555555'
            }

            //cajas.id_temporal=listaCajas.Cajas.length;
            cajas.Cajas[0].id_temporal = listaCajas.Cajas.length;
            listaCajas.Cajas.push(cajas.Cajas[0]);
            refCajas.set(listaCajas)

            //LOS COLORES NO POR QUE SON A NIVEL FRANQUICIA


            resolve(docRef.id)
          })

      })
    },
    async actualizarSucursal({ dispatch }, sucursal) {

      try {

        const promesas = []

        promesas.push(
          db.collection(FS_COLLECTIONS.SUCURSALES)
            .doc(sucursal.id).update(sucursal)
        )

        promesas.push(
          dispatch('asignarSucursalEnAlmacenes', {
            id_sucursal: sucursal.id,
            almacenes: sucursal.almacenes,
          })
        )

        await Promise.all(promesas)

        return true;

      } catch (e) {

        throw e;

      }

    },
    async asignarSucursalEnAlmacenes({ getters }, props) {

      const { id_sucursal, almacenes } = props

      console.log("Asigna sucurales en almacenes ", almacenes)

      try {

        if (!Object.keys(almacenes).length) return

        const batch = db.batch()

        for (const i in almacenes) {

          const doc = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.ALMACENES).doc(i)

          batch.update(doc, { id_sucursal })

        }

        await batch.commit()

        return true;

      } catch (e) {

        throw e

      }

    },
    subirArchivoFranquicia({ getters }, archivo) {
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/logo/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    cargaSucursal({ commit }, idSucursal) {

      console.log('idSucursal', idSucursal);
      //Añadido por William 11/02/2021 porque a veces hacia que tronara en otros lados
      if (!idSucursal) return

      return new Promise((resolve, reject) => {

        //if (cargadorSucursalActual === null) {
        let docPath = db.collection(FS_COLLECTIONS.SUCURSALES).doc(idSucursal)

        cargadorSucursalActual = docPath.onSnapshot(doc => {
          console.log('Current data Sucursal: ', doc.data())
          commit('ASIGNA_SUCURSAL_ACTUAL', doc.data())
          commit('ASIGNA_SUCURSAL_ACTUAL_LOCAL', doc.data())
          resolve(doc.data())
        })

        //}else{
        //resolve()
        //}

      })

    },
    subirArchivoSucursal({ getters }, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/Sucursales/${archivo.idSucursal}/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },

    actualizarNotificacionesAutomaticasFranquicia({ getters }, notificacion) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).set({ enviar_notificaciones_automaticas: notificacion }, { merge: true }).then(() => {
          resolve()
        }).catch(error => {
          reject(error);
        })
      })
    },


    getFranquiciaStatic({ }, idFranquicia) {
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(idFranquicia)
        docPath.get().then(doc => {
          if (!doc.exists) resolve(null);
          resolve(doc.data())
        }).catch(error => {
          reject(error)
        })
      })
    },


  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/franquicias/franquicias.js